export default {
    state: {
	singleGetPrices: false
    },
    setSingleGetPrices(newValue) {
	this.state.singleGetPrices = newValue
    }
}



// WEBPACK FOOTER //
// ./src/store.js